import { CsvSvg, ExcelSvg, PdfSvg } from "../style/iconStyle";

const ExportData = ({ export_type, includes = ['pdf', 'csv'] }:{
    export_type?: (val:string) => void,
    includes?: string[]
}) => (
    <div className="export_data__container">
        {includes.includes('pdf') && (
            <button onClick={() => export_type && export_type("pdf")}>
                <PdfSvg />
            </button>
        )}

        {includes.includes('csv') && (
            <button onClick={() => export_type && export_type("csv")}>
                <CsvSvg />
            </button>
        )}

        {includes.includes('excel') && (
            <button title="Export to Excel" onClick={() => export_type && export_type("excel")}>
                <ExcelSvg />
            </button>
        )}
    </div>
)

export default ExportData;